import MiniApi from "@momo-miniapp/api";
export const MOMO = MiniApi;
export default MOMO;